import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isMenuOpen: false,
    currentLanguage: 'zh',
    menuItems: [
      {
        title: '首页',
        path: '/',
        children: []
      },
      {
        title: '动态资讯',
        path: '/Dynamic',
        children: [
          { title: '企业动态', path: '/Dynamic?tab=company' },
          { title: '行业资讯', path: '/Dynamic?tab=industry' },
        ]
      },
      {
        title: '行业案例',
        path: '/Industry',
        children: [
          { title: '信息化项目造价咨询', path: '/Industry?tab=xxhxmzjzx' },
          { title: '工程项目造价咨询', path: '/Industry?tab=gzxmzjzx' },
          { title: '可行性研究报告', path: '/Industry?tab=kxxyjbg' },
        ]
      },
      // {
      //   title: '应用案例',
      //   path: '/cases',
      //   children: []
      // },
      // {
      //   title: '技术支持',
      //   path: '/support',
      //   children: [
      //     { title: '技术资料', path: '/support/documents' },
      //     { title: '软件下载', path: '/support/downloads' },
      //     { title: '常见问题', path: '/support/faq' },
      //     { title: '在线技术支持', path: '/support/online' }
      //   ]
      // },
      {
        title: '关于我们',
        path: '/about',
        children: [
          { title: '公司简介', path: '/about?tab=introduction' },
          { title: '企业文化', path: '/about?tab=culture' },
          { title: '技术实力', path: '/about?tab=introduction2' },
          { title: '发展历程', path: '/about?tab=history' },
          { title: '资质荣誉', path: '/about?tab=honors' },
          { title: '公司剪影', path: '/about?tab=team' }
        ]
      },
      // {
      //   title: '新闻资讯',
      //   path: '/news',
      //   children: [
      //     { title: '公司新闻', path: '/news/company' },
      //     { title: '行业新闻', path: '/news/industry' },
      //     { title: '展会信息', path: '/news/exhibition' }
      //   ]
      // },
      {
        title: '联系我们',
        path: '/contact',
        children: []
      }
    ]
  },
  mutations: {
    toggleMenu(state) {
      state.isMenuOpen = !state.isMenuOpen
    },
    closeMenu(state) {
      state.isMenuOpen = false
    },
    setLanguage(state, lang) {
      state.currentLanguage = lang
    },
    setMenuOpen (state, isOpen) {
      state.isMenuOpen = isOpen
    }
  },
  actions: {},
  modules: {}
}) 